// src/components/ui/Spinner.jsx
import { createPortal } from "react-dom";

export default function Spinner({
  size = 32,
  color = "#ed354f",
  overlay = false,
  className = "",
  overlayClassName = "",
  ariaLabel = "",
}) {
  const ariaProps = ariaLabel
    ? { role: "status", "aria-label": ariaLabel, "aria-live": "polite" }
    : { "aria-hidden": true };

  const spinner = (
    <div
      {...ariaProps}
      className={`animate-spin rounded-full border-[3px] border-[#f58ba0]/50 ${className}`}
      style={{
        width: size,
        height: size,
        borderTopColor: color,
      }}
    />
  );

  if (overlay) {
    return createPortal(
      <div className={`fixed inset-0 z-[9999] backdrop-blur-sm flex items-center justify-center ${overlayClassName}`}>
        {spinner}
      </div>,
      document.body
    );
  }

  return spinner;
}
